import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
import { ScrollRestoration } from 'react-router-dom';

export function Layout() {
  const location = useLocation();
  const showFooter =
    location.pathname !== '/ai-trip' && !location.pathname.startsWith('/destination');

  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <Outlet />
      </main>
      {showFooter && <Footer />}
      <ScrollRestoration />
    </div>
  );
}

